import { PesquisaComponent } from './pesquisa/pesquisa.component';
import { ROuvidoriaComponent } from './r-ouvidoria/r-ouvidoria.component';
import { ArquivoInfoComponent } from './arquivo-info/arquivo-info.component';
import { ConsultaCensoComponent } from './consulta-censo/consulta-censo.component';
import { CensoDigitalComponent } from './relatorios/censo-digital/censo-digital.component';
import { InscritorComponent } from './inscricoes/inscritor/inscritor.component';
import { AutenticadorComponent } from './autenticador/autenticador.component';
import { CredenciadosComponent } from './credenciados/credenciados.component';
import { CertidaoDebitoComponent } from './certidao-debito/certidao-debito.component';
import { ConselhoAdministrativoComponent } from './conselho-administrativo/conselho-administrativo.component';
import { RelInvestimentosComponent } from './rel-investimentos/rel-investimentos.component';
import { ArquivospComponent } from './arquivosp/arquivosp.component';
import { CadastroPersonalizadoComponent } from './cadastro-personalizado/cadastro-personalizado.component';
import { CadastroServidorComponent } from './cadastro-servidor/cadastro-servidor.component';
import { ProgestaoComponent } from './progestao/progestao.component';
import { LicitacaoViewComponent } from './licitacao-view/licitacao-view.component';
import { LicitacaoComponent } from './licitacao/licitacao.component';
import { FaleconoscoComponent } from './faleconosco/faleconosco.component';
import { CadastroComponent } from './cadastro/cadastro.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ArquivosComponent } from './arquivos/arquivos.component';
import { ViewPessoaComponent } from './view-pessoa/view-pessoa.component';
import { ConselhoFiscalComponent } from './conselho-fiscal/conselho-fiscal.component';
import { JuntaRecursosComponent } from './junta-recursos/junta-recursos.component';
import { ComiteInvestimentosComponent } from './comite-investimentos/comite-investimentos.component';
import { TelaContabeisComponent } from './tela-contabeis/tela-contabeis.component';
import { DiretoriaExecutivaComponent } from './diretoria-executiva/diretoria-executiva.component';
import { AgendaComponent } from './agenda/agenda.component';
import { RelatorioControleInternoComponent } from './relatorio-controle-interno/relatorio-controle-interno.component';
import { OrganizacaoComponent } from './organizacao/organizacao.component';
import { SenhaCadastroServidorGuard } from './guards/senha-cadastro-servidor.guard';

const routes: Routes = [
  { path: 'arquivos/:categoria', component: ArquivosComponent},
  { path: 'arquivosp/:categoria', component: ArquivospComponent},
  { path: 'arquivoinfo/:categoria', component: ArquivoInfoComponent},
  { path: 'agenda', component: AgendaComponent},
  { path: 'pessoa/:id/:detalhe/:grupo', component: ViewPessoaComponent},
  { path: 'inscricao/:id', component: InscritorComponent},
  { path: 'cadastro', component: CadastroComponent},
  { path: 'cadastroPersonalizado', component: CadastroPersonalizadoComponent},
  { path: 'relatorioInvestimentos', component: RelInvestimentosComponent},
  { path: 'conselhoAdministrativo', component: ConselhoAdministrativoComponent},
  { path: 'conselhoFiscal', component: ConselhoFiscalComponent},
  { path: 'juntaRecursos', component: JuntaRecursosComponent},
  { path: 'relatorioDeOuvidoria', component: ROuvidoriaComponent},
  { path: 'credenciados', component: CredenciadosComponent},
  { path: 'comiteInvestimentos', component: ComiteInvestimentosComponent},
  { path: 'diretoriaExecutiva', component: DiretoriaExecutivaComponent},
  { path: 'dadosContabeis', component: TelaContabeisComponent},
  { path: 'autenticador', component: AutenticadorComponent},
  { path: 'licitacao', component: LicitacaoComponent},
  { path: 'pesquisa', component: PesquisaComponent},
  { path: 'relatorio-controle-interno', component: RelatorioControleInternoComponent},
  { path: 'certidoes', component: CertidaoDebitoComponent},
  { path: 'progestao', component: ProgestaoComponent},
  { path: 'cadastroServidor', component: CadastroServidorComponent, canActivate: [SenhaCadastroServidorGuard]},
  { path: 'licitacaoView/:categoria', component: LicitacaoViewComponent},
  { path: 'censoDigital/:censo', component: CensoDigitalComponent},
  { path: 'consulta/:censo/:secretaria', component: ConsultaCensoComponent},
  { path: 'faleConosco', component: FaleconoscoComponent},
  { path: 'organizacao', component: OrganizacaoComponent},
  { path: '', pathMatch: 'full', redirectTo: 'arquivos/novo' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash:true})],
  exports: [RouterModule]
})
export class AppRoutingModule { } 
